/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { DeleteSmsTfaOptionErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const tfaSms = () => {
  return api<void>({ url: `/api/auth/tfa/sms`, method: 'DELETE' });
};

export const getTfaSmsMutationOptions = <
  TError = DeleteSmsTfaOptionErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof tfaSms>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof tfaSms>>, TError, void, TContext> => {
  const mutationKey = ['tfaSms'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof tfaSms>>, void> = () => {
    return tfaSms();
  };

  return { mutationFn, ...mutationOptions };
};

export type TfaSmsMutationResult = NonNullable<Awaited<ReturnType<typeof tfaSms>>>;

export type TfaSmsMutationError = DeleteSmsTfaOptionErrorResponse;

export const useTfaSms = <TError = DeleteSmsTfaOptionErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof tfaSms>>, TError, void, TContext>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof tfaSms>>, TError, void, TContext> => {
  const mutationOptions = getTfaSmsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
